// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_Rpx","cls2":"PodcastLibraryCarouselAd-cls2_vKi PodcastLibraryCarouselAd-cls1_Rpx"};